import r from "./highrise1439.mjs";
var t = r("toUpperCase");
export {
  t as default
};
